import { toast } from 'react-toastify'
import { StoreonModule } from 'storeon'
import { api } from '@/api'
import { Events, State } from '../../interfaces'

export const servicesModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    // Общий список услуг
    services: [],
    // Статус загрузки
    statusLoadServices: false
  }))

  // Общий список услуг
  store.on('services/get', async (state, event) => {
    try {
      store.dispatch('statusLoadServices', true)
      const data = await api.services.getServices({ ...event })
      store.dispatch('services/save', data)
      store.dispatch('statusLoadServices', false)
    } catch (e) {
      toast.error('Ошибка получения Услуг!')
    }
  })

  store.on('services/save', (state, event) => {
    try {
      return {
        services: event
      }
    } catch (e) {
      console.error(e)
    }
    return null
  })
}
